import {
  StatsDataFragment,
  StatsDataTestHorizonStrategy,
} from '@spotify/confidence-graphql';

export const useIsStatsModuleStrategySequentialV2 = (
  statsData?: StatsDataFragment,
) => statsData?.testHorizonStrategy === StatsDataTestHorizonStrategy.Sequential;
